import { useForm as createUseForm } from "@ant-design-vue/use";
import lodash from "lodash";
import { defineAsyncComponent, reactive, toRaw } from "vue";
import { addModal } from "../../../../app.logic";
import {
    createFieldCheckbox,
    createFieldSelect,
    createFieldTemplateBuilder
} from "../../../../components/input/template-builder/template-builder.logic";
import { createColumnInlineCheckbox, createColumnInlineSelect, createColumnInput } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import { createButtonCreate } from "../../../../utils/button";
import { modalStyleForm } from "../../../../utils/constant";
import { initUseForm, onClickDeleteAllClient } from "../../../../utils/form";
import { onIFrameClickSelectAll } from "../../../../utils/iframe";
import { createLoading } from "../../../../utils/loading";
import { has } from "../../../../utils/menu-context";
import { createManageDelete, createManageExportCsv, createPage, createRowActionEdit, createRowActionView } from "../../../../utils/page";
import { validateError } from "../../../../utils/validate";
import { openModalList as openModalListCompanyProduct } from "../../company/company-product/company-product.logic";
import { callSamplingCondition } from "../company/company.section";

const CompanyDocRejectProductForm = defineAsyncComponent(() => import("./CompanyDocRejectProductForm"));

export const { isLoading, setIsLoading } = createLoading();

export const callCompanyCountryStatus = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "COMPANY_COUNTRY_STATUS", value: searchQuery });
export const callCompanyCountryStatusByKey = ({ key }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "COMPANY_COUNTRY_STATUS", key });
export const callCompanyTopic = ({ searchQuery }) => store.dispatch("resource/v1/master/labCompany/cacheFindAll", { searchQuery });
export const callCompanyProductByIds = ({ ids }) => {
    return store
        .dispatch("resource/v1/transaction/companyProduct/search", {
            criteria: {
                select: ["**", "refCompanyProduct.**"],
                page: 0,
                size: 1000000,
                where: [
                    { name: "isActive", type: "Boolean", operator: "=", value: true },
                    { name: "id", type: "UUID", operator: "in", value: ids }
                ]
            }
        })
        .then(page => page.data);
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const createColumns = ({ props, data }) => {
    const {
        itemsKey,
        visibleCompanyDocReject,
        visibleSamplingProduct,
        disabledSamplingCondition,
        disabledIsSuspendedSampling,
        disabledIsSuspendedHc
    } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    const columns = [];
    if (visibleCompanyDocReject) {
        columns.push(createColumnInput({ title: () => i18n.global.t("model.companyDocReject.docNo"), dataIndex: "refCompanyDocReject.docNo" }));
    }
    if (visibleSamplingProduct) {
        columns.push(
            createColumnInput({
                title: () => i18n.global.t("model.product.code"),
                dataIndex: "refCompanyProduct.refProduct.code",
                align: "center"
            })
        );
        columns.push(
            createColumnInput({
                title: () => i18n.global.t("model.product.nameTh"),
                dataIndex: "refCompanyProduct.refProduct.nameTh",
                width: 200
            })
        );
        columns.push(
            createColumnInput({
                title: () => i18n.global.t("model.product.nameEn"),
                dataIndex: "refCompanyProduct.refProduct.nameEn",
                width: 200
            })
        );
    }
    columns.push(
        createColumnInlineSelect({
            title: () => i18n.global.t("model.companyProduct.refSamplingCondition"),
            dataIndex: "refSamplingCondition",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ list: callSamplingCondition }),
            customRenderInputProp: ({ record }) => {
                return {
                    value: record.refCompanyProduct?.refSamplingCondition,
                    "onUpdate:value": value => {
                        record.isSave = true;
                        record.refCompanyProduct.isSave = true;
                        record.refCompanyProduct.refSamplingCondition = value;
                    },
                    disabled: disabledSamplingCondition,
                    list: callSamplingCondition,
                    optLabel: "value",
                    allowClear: false
                };
            }
        })
    );
    columns.push(
        createColumnInlineCheckbox({
            title: () => i18n.global.t("model.companyDocRejectProduct.isSuspendedSampling"),
            dataIndex: "isSuspendedSampling",
            customRenderInputProp: ({ record }) => {
                return {
                    checked: record.refCompanyProduct?.isSuspendedSampling,
                    "onUpdate:checked": checked => {
                        record.isSave = true;
                        record.refCompanyProduct.isSave = true;
                        record.refCompanyProduct.isSuspendedSampling = checked;
                        if (checked) {
                            record.refCompanyProduct.refDocRejectStatus = modelRef.refCompanyDocRejectType;
                        } else {
                            record.refCompanyProduct.refDocRejectStatus = null;
                        }
                    },
                    disabled: disabledIsSuspendedSampling
                };
            }
        })
    );
    columns.push(
        createColumnInlineCheckbox({
            title: () => i18n.global.t("model.companyDocRejectProduct.isSuspendedHc"),
            dataIndex: "isSuspendedHc",
            customRenderInputProp: ({ record }) => {
                return {
                    checked: record.refCompanyProduct?.isSuspendedHc,
                    "onUpdate:checked": checked => {
                        record.refCompanyProduct.isSave = true;
                        record.refCompanyProduct.isSuspendedHc = checked;
                        if (checked) {
                            record.refCompanyProduct.refDocRejectStatus = modelRef.refCompanyDocRejectType;
                        } else {
                            record.refCompanyProduct.refDocRejectStatus = null;
                        }
                    },
                    disabled: disabledIsSuspendedHc
                };
            }
        })
    );
    return columns;
};

export const createForm = () => {
    return {
        refCompanyDocReject: null,
        refCompanyProduct: null,
        refSamplingProduct: null,
        isMicro: null,
        isChemi: null,
        isPhysic: null,
        analysiss: [],
        topics: [],
        samplingProducts: []
    };
};

export const createRules = () => {
    return {};
};

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, itemsKey, visibleCompanyDocReject, visibleSamplingProduct, visibleRowAction } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: items });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => (viewOnly ? false : has({ menuContext, key: "canDelete" })),
            onClick: ({ rowSelection }) => onClickDeleteAllClient({ rowSelection, useForm, items, key: itemsKey })
        }),
        createManageExportCsv({ menuContext })
    ];
    data.manageExtras = [];
    data.rowActions = [];
    if (visibleRowAction) {
        data.rowActions.push(
            createRowActionView({
                menuContext,
                onClick: ({ record }) => {
                    const menuContextClone = lodash.cloneDeep(menuContext);
                    menuContextClone.attribute.push("forCompany");
                    openModalForm({ props: { menuContext: menuContextClone, viewOnly: true, setAppPageHeader: false, form: record } });
                },
                visible: () => has({ menuContext: menuContext, key: "canView" })
            })
        );
    }

    if (!viewOnly) {
        if (visibleRowAction) {
            data.rowActions.push(
                createRowActionEdit({
                    menuContext,
                    onClick: ({ record }) => {
                        const menuContextClone = lodash.cloneDeep(menuContext);
                        menuContextClone.attribute.push("forCompany");
                        openModalForm({ props: { menuContext: menuContextClone, viewOnly, setAppPageHeader: false, form: record } });
                    },
                    visible: () => has({ menuContext: menuContext, key: "canEdit" })
                })
            );
        }
        if (visibleCompanyDocReject) {
            /*
            data.manageExtras.push({
                render: () => ({
                    ...createButtonCreate({
                        onClick: () => openModalListCompany({
                            onIframeMounted: ({ refs, options }) => onIFrameClickSelectAll({
                                refs, options, items, itemKey: 'refCompany.id', rowKey: 'id', setKey: 'refCompany'
                            }),
                        }),
                        options: { text: i18n.global.t('model.companyCountry.refCompany') }
                    }),
                }),
                visible: () => has({ menuContext, key: 'canCreate' }),
            })
            */
        }
        if (visibleSamplingProduct) {
            data.manageExtras.push({
                render: () => ({
                    ...createButtonCreate({
                        onClick: () =>
                            openModalListCompanyProduct({
                                onIframeMounted: ({ refs, options }) =>
                                    onIFrameClickSelectAll({
                                        refs,
                                        options,
                                        items,
                                        itemKey: "refCompanyProduct.id",
                                        rowKey: "id",
                                        setKey: "refCompanyProduct",
                                        onSearch: ({ page }) => {
                                            const value = items.filter(d => d.isDelete !== true).map(d => d.refCompanyProduct?.id);
                                            page.where.push({
                                                name: "refCompany.id",
                                                type: "UUID",
                                                operator: "=",
                                                value: data.useForm.modelRef.refCompany?.id
                                            });
                                            if (value.length > 0) {
                                                page.where.push(
                                                    { name: "id", type: "UUID", operator: "!in", value },
                                                    { name: "refStatus.key", type: "String", operator: "=", value: "Approve" }
                                                );
                                            }
                                        },
                                        afterSelect: ({ rowSelection }) => {
                                            callCompanyProductByIds({ ids: rowSelection.selectedRowKeys }).then(companyProducts => {
                                                companyProducts.forEach(companyProduct => {
                                                    const companyDocRejectProduct = items.find(
                                                        item => companyProduct.id === item.refCompanyProduct?.id
                                                    );
                                                    lodash.merge(companyDocRejectProduct.refCompanyProduct, companyProduct);
                                                    if (!companyDocRejectProduct.analysiss) companyDocRejectProduct.analysiss = [];
                                                    if (!companyDocRejectProduct.topics) companyDocRejectProduct.topics = [];
                                                });

                                                // for refresh table
                                                const tmp = items.splice(items.length - 1, 1);
                                                items.push(...tmp);
                                            });
                                        }
                                    })
                            }),
                        options: { text: i18n.global.t("views.company.companyDocReject.manageProduct.title") }
                    })
                }),
                visible: () => has({ menuContext, key: "canCreate" })
            });
        }
    }
};

export const createField = ({ props, data, key }) => {
    /*
    data.useForm.modelRef.refCompanyCountry1 = "1"; // for use createFieldAnalysis
    return [
        ...createFieldAnalysis({
            props,
            data,
            key: "isMicro",
            refLabTypeKey: "labMicro",
            label: i18n.global.t("model.samplingProduct.labels.labDof")
        }),
        ...createFieldAnalysis({ props, data, key: "isChemi", refLabTypeKey: "labChemi" }),
        ...createFieldAnalysis({ props, data, key: "isPhysic", refLabTypeKey: "labPhysic" })
    ];
    */
    // create Field
    return [
        createFieldTopic({ props, data, key, lab: "Micro" }),
        createFieldTopic({ props, data, key, lab: "Chemi" }),
        createFieldTopic({ props, data, key, lab: "Physic" })
    ];
};

export const createFieldTopic = ({ props, data, key, lab }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return createFieldTemplateBuilder({
        colProp: () => ({ xs: 24 }),
        inputProp: () => ({
            useForm: useForm,
            fields: [
                createFieldCheckbox({
                    key: `${prefix}.is${lab}`,
                    colProp: () => ({ xs: 24, md: 8 }),
                    formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                    inputProp: () => ({
                        checked: model[`is${lab}`],
                        "onUpdate:checked": checked => {
                            model.isSave = true;
                            model[`is${lab}`] = checked;
                            if (!checked) {
                                lodash.remove(model.topics, d => d.refLabType?.key === `lab${lab}` && !d.id);
                                model.topics.filter(d => d.refLabType?.key === `lab${lab}`).forEach(d => (d.isDelete = true));
                            }
                        },
                        disabled: viewOnly,
                        text: () => i18n.global.t(`model.samplingProduct.is${lab}`)
                    })
                }),
                createFieldSelect({
                    key: `${prefix}topics`,
                    colProp: () => ({ xs: 24, md: 16 }),
                    formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                    inputProp: () => ({
                        value: model.topics,
                        "onUpdate:value": value => {
                            model.isSave = true;
                            model.topics = value;
                        },
                        disabled: viewOnly || !model[`is${lab}`],
                        list: ({ searchQuery }) =>
                            callCompanyTopic({ searchQuery }).then(items =>
                                items.filter(item => item.refLabType?.key === `lab${lab}`).map(item => ({ refTopic: item }))
                            ),
                        optLabel: "refTopic.name",
                        optKey: "refTopic.id",
                        mode: "multiple",
                        visibleItem: ({ item, value }) => item?.refLabType?.key === `lab${lab}` || value?.refTopic?.refLabType?.key === `lab${lab}`,
                        placeholder: i18n.global.t("lab.labTopic")
                    }),
                    changeLog: { getValueChildren: ({ record }) => record.refTopic?.name }
                })
            ],
            skeleton: isLoading.value
        })
    });
};

export const loadForm = ({ props, data, refs }) => {
    setIsLoading(true);
    const { form, routerPrefix } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise
        .then(page => initUseForm({ props, data, refs, page, routerPrefix }))
        .then(() => loadDefaultForm({ props, data }))
        .then(() => initUseForm({ props, data, refs, page: { data: [modelRef] }, routerPrefix }))
        .finally(() => setIsLoading(false));
};

export const loadDefaultForm = () => {
    const promises = [];
    return Promise.all(promises);
};

export const initForm = ({ props, data, refs }) => {
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
    loadForm({ props, data, refs });
};

export const openModalForm = ({ props, items }) => {
    const refs = reactive({ form: null });
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleForm), {
            okButtonProps: { disabled: props.viewOnly },
            header: i18n.global.t("views.company.companyDocReject.lab.title"),
            onOk: () => {
                refs.form.callOnClickModalOk().then(record => {
                    if (items) {
                        items.push(record);
                    } else {
                        lodash.merge(props.form, record);
                    }
                    options.bind.onCancel();
                });
            }
        }),
        render: () => (
            <CompanyDocRejectProductForm
                ref={e => {
                    if (e) refs.form = e;
                }}
                {...props}
            ></CompanyDocRejectProductForm>
        )
    });
    return options;
};
